<template>
  <Teleport to="body">
    <template v-if="systemStore.maintenanceMode">
      <!-- Backdrop -->
      <div class="fixed inset-0 z-40 backdrop-blur-xs backdrop-brightness-75" />

      <!-- Modal content -->
      <div class="fixed inset-0 z-50 flex items-center justify-center p-4">
        <div
          class="w-full max-w-md rounded-xl bg-white p-8 shadow-2xl ring-1 ring-gray-200 dark:bg-slate-800 dark:ring-slate-700">
          <!-- Maintenance icon -->
          <div
            class="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900/30">
            <WrenchScrewdriverIcon class="h-10 w-10 text-amber-600 dark:text-amber-400" aria-hidden="true" />
          </div>

          <!-- Content -->
          <div class="mt-6 text-center">
            <h3 class="text-xl font-semibold text-gray-900 dark:text-white"> Scheduled Maintenance </h3>
            <p class="mt-3 text-sm text-gray-600 dark:text-gray-300">
              {{
                systemStore.maintenanceMessage ||
                "RightMessage is undergoing scheduled maintenance. We'll be back shortly."
              }}
            </p>
            <p v-if="systemStore.maintenanceEta" class="mt-2 text-sm font-medium text-gray-500 dark:text-gray-400">
              Estimated time: {{ systemStore.maintenanceEta }}
            </p>
          </div>

          <!-- Loading indicator -->
          <div class="mt-8 flex justify-center">
            <svg
              class="h-8 w-8 animate-spin text-amber-600 dark:text-amber-400"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
              <path
                class="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z" />
            </svg>
          </div>
        </div>
      </div>
    </template>
  </Teleport>
</template>

<script setup lang="ts">
import { WrenchScrewdriverIcon } from '@heroicons/vue/24/outline'
import { useScrollLock } from '@vueuse/core'
import { useSystemStore } from '@dashboard/stores/systemStore'
import { watch } from 'vue'

const systemStore = useSystemStore()

const isLocked = useScrollLock(document.body)

watch(
  () => systemStore.maintenanceMode,
  (active) => {
    isLocked.value = active
  },
  { immediate: true }
)
</script>
